import { useContext } from "react";
import { CartContext, SettingsContext, ShopContext } from "../../App";
import CartQtySelector from "../CartQtySelector";
import currencyFormat, { replaceAll } from "../functions/functions";
import NotesIcon from "../../icons/NotesIcon";
import DotIcon from "../../icons/DotIcon";

function Product({
	index,
	product,
	timerActive,
	updateQty,
	showNickname = true,
	displayQty = null,
	nickname = null,
	nicknameLabel = null,
}) {
	const { settings, setProductNotesPopup } = useContext(SettingsContext);
	const { shop } = useContext(ShopContext);
	const { cart } = useContext(CartContext);
	// Quota reale di questa riga (scontata o clone a prezzo pieno): usata per prezzo, numero mostrato e stepper
	const qty = displayQty ?? product.qty;

	return (
		<div className="cart-row">
			<div className="name">
				{cart.allyoucaneat == 1 && (settings.selfordering?.disable_timer_for_priced == 1 || product.exclude_from_ayce == 1 || cart.rounds?.exhausted) && (
					<>
						{product.price == 0 && (timerActive || cart.rounds?.exhausted) && !product.exclude_from_ayce ? (
							<DotIcon className="text-danger"></DotIcon>
						) : (
							<DotIcon className="text-success"></DotIcon>
						)}
					</>
				)}
				{product.name}
				{product.discounted == 1 ? (
					<div className="small">
						<s>{currencyFormat(product.base_price, false, shop.currency)}</s>{" "}
						{currencyFormat(product.price, false, shop.currency)}
					</div>
				) : (
					<div className="small">
						{currencyFormat(product.price, false, shop.currency)}
					</div>
				)}
				<div className="small">
					{product.variants.map((variant, i) => (
						<span key={i}>
							{variant.qty}x {variant.name}
							{i < product.variants.length - 1 && ", "}
						</span>
					))}
				</div>
				{product.products?.map((subproduct, i) => (
					<div
						key={subproduct.variant_category_id + "-" + subproduct.product_id}
						className="small"
					>
						<div>
							{subproduct.qty}x {subproduct.name}
						</div>
					</div>
				))}
				<div className="small">
					{product.notes && product.notes.replace(/<br\s*[\/]?>/gi, "\n")}
					{showNickname && nicknameLabel}
				</div>
			</div>
			<div className="prices">
				<div className="qty">
					{product.removable == 1 ? (
						<CartQtySelector
							value={qty}
							onChange={(qty) =>
								updateQty(
									product.product_id,
									product.item_id,
									qty,
									product.price,
									false,
									nickname,
									product.qty,
									product.qty_unsplitted ?? product.qty
								)
							}
						/>
					) : (
						qty
					)}
					{settings.selfordering?.enable_products_notes == 1 && (
						<button
							className="notes-button"
							onClick={() => setProductNotesPopup(product.item_id)}
						>
							<NotesIcon />
						</button>
					)}
				</div>
				<div className="price">
					{currencyFormat(
						parseInt(qty) * parseFloat(product.price),
						false,
						shop.currency
					)}
				</div>
			</div>
		</div>
	);
}

export default Product;
